import { Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type AlbumSortOrder } from "../../../../../../Album/types/album-sort.types.ts"

interface AlbumsSortSelectProps {
  value: AlbumSortOrder
  onChange: (value: AlbumSortOrder) => void
}

export function AlbumsSortSelect({ value, onChange }: AlbumsSortSelectProps) {
  const { t } = useTranslation()

  const options: { label: string; value: AlbumSortOrder }[] = [
    { label: t("files.albums.sort.modifiedDesc"), value: "modified_desc" },
    { label: t("files.albums.sort.createdDesc"), value: "created_desc" },
    { label: t("files.albums.sort.nameAsc"), value: "name_asc" },
    { label: t("files.albums.sort.nameDesc"), value: "name_desc" },
    { label: t("files.albums.sort.filesDesc"), value: "files_desc" },
    { label: t("files.albums.sort.filesAsc"), value: "files_asc" }
  ]

  return (
    <Select<AlbumSortOrder>
      value={value}
      onChange={onChange}
      options={options}
      aria-label={t("files.albums.sort.label")}
      className="w-[190px]"
      labelRender={({ label }) => (
        <>
          {t("files.albums.sort.prefix")}: {label}
        </>
      )}
    />
  )
}
